import React from 'react';
import '../../styles/RankUpgradeModal.css';
import { Sparkles, CheckCircle } from 'lucide-react';

const RankUpgradeModal = ({ rank, onClose }) => {
    if (!rank) return null;

    return (
        <div className="rank-modal-overlay">
            <div className="rank-modal-card">
                <div className="rank-modal-confetti"></div>
                
                <div className="rank-modal-header">
                    <Sparkles className="icon-sparkle" />
                    <h2>¡NUEVO RANGO ALCANZADO!</h2>
                    <Sparkles className="icon-sparkle" />
                </div>

                <div className="rank-modal-body">
                    <div className="rank-image-container">
                        {rank.pinImage && <img src={`/${rank.pinImage}`} alt={rank.name} className="rank-badge-image" />}
                        <div className={`rank-glow ${rank.id}`}></div>
                    </div>

                    <h1 className="rank-title">{rank.name}</h1>
                    {rank.shortDescription && <p className="rank-subtitle">{rank.shortDescription}</p>}

                    <div className="rank-rewards-box">
                        <h3>Tus Premios:</h3>
                        <ul>
                            {rank.prize && rank.prize.map((reward, index) => (
                                <li key={index}>
                                    <CheckCircle size={16} className="reward-check-icon" />
                                    {/* Asegúrate de que los premios no sean nulos o vacíos */}
                                    {reward || 'Reconocimiento'}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="rank-modal-footer">
                    <button onClick={onClose} className="lignums-button rank-confirm-btn">
                        CONTINUAR MI CARRERA
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RankUpgradeModal;